import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import underConstructionSite from "../../images/underConstructionPage.jpg";

import axios from "axios";

import "./rank.css";

const Rank = () => {
	const history = useHistory();
	const [activeRooms, setActiveRooms] = useState([]); // PV: ["string"]
	useEffect(() => {
		getRoomActive();
	}, []);

	function getRoomActive() {
		console.log("getRoomActive");
		axios
			.get(`/api/rank/users/`)
			.then(res => {
				console.log(res.data);
				let sortedData = [];
				res.data.forEach(element => {
					sortedData.push({
						username: element.username,
						points: parseInt(element.win * 100 + element.draw * 25),
					});
				});
				// sort by value
				sortedData.sort(function (a, b) {
					return b.points - a.points;
				});
				setActiveRooms(sortedData);
			})
			.catch(err => console.log(err));
	}

	function displayListOfRooms() {
		if (activeRooms) {
			return activeRooms.map((user, index) => (
				<div className={index % 2 == 0 ? "room-container even" : "room-container odd"} key={index}>
					<div className="left">
						<h1 className="room">{user.username}</h1>
					</div>
					<div className="right">
						<h1 className="room">{`${user.points}pts`}</h1>
					</div>
				</div>
			));
		}
	}

	return (
		<div className="watch-page">
			<input type="submit" className="logout-btn" value="BACK" onClick={() => history.push("/login")} />
			<div className="watch-container">
				<h1 className="watch-title">Rank</h1>
				<div className="list-container">
					<div className="refresh" onClick={e => getRoomActive()}>
						REFRESH
					</div>
					{activeRooms.length === 0 ? <h1 className="empty-room">no one is playing right now...</h1> : displayListOfRooms()}
				</div>
			</div>
		</div>
	);
};

export default Rank;
